export default {
	page: "Page",
	of: "of",
	itemsPerPage: "Items per page",
	totalItems: "Showing {start} to {end} of {total} entries",
};
